import { isDesktop, onTabletToDesktop } from '../utils/index.js';
import initTooltips from './tooltip-popup.js';
import { getSiteConfiguration } from '../site-configuration.js';

const offsetTooltips = () => {
  const desktopTooltips = [...document.querySelectorAll('.hyphenate .js-tooltip-container')];
  const docsContainer = document.querySelector('.tabs-content') || document.querySelector('.docs-container');
  const { enableRightToLeftLayout: isRTL } = getSiteConfiguration();
  const horizontalProperty = isRTL ? 'right' : 'left';

  const bodyRect = docsContainer ? docsContainer.getBoundingClientRect()[horizontalProperty] : 0;
  let horizontalOffset;

  desktopTooltips.forEach((tooltip) => {
    const tooltipBody = tooltip.querySelector('.tooltip-body');
    const tooltipBodyRect = tooltipBody.getBoundingClientRect()[horizontalProperty];

    horizontalOffset = bodyRect - tooltipBodyRect;
    if (horizontalOffset > 0 || (isRTL && horizontalOffset < 0)) {
      tooltipBody.classList.add('tooltip-body__offset');
    }
  });
};

export const initTooltipsWithOffset = (tooltipsContainer) => {
  if (!tooltipsContainer) {
    return;
  }

  onTabletToDesktop(offsetTooltips);

  if (isDesktop()) {
    offsetTooltips();
  }

  initTooltips(tooltipsContainer);
};
